import React from 'react';

import { HashRouter as Router, Switch, Route } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import Top from './Top'
import Author from './Author'
import AuthorWill from './AuthorWill'
import Property from './Property'
import Testament from './Testament'
import Heiress from './Heiress'

import Money from './Money' // 現金
import Deposit from './Deposit' // 預貯金
import Land from './Land' // 土地
import Building from './Building' // 建物
import Apartment from './Apartment' // マンション
import Stock from './Stock' // 国債・株式・社債
import Fund from './Fund' // 投資信託
import Insurance from './Insurance' // 保険金・保険解約の解約払い戻し金
import Bond from './Bond' // 債権
import Debt from './Debt' // 債務
import Automobile from './Automobile' // 自動車
import Other from './Other' // その他

import ScrollToTop from './ScrollToTop' // その他

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
}));

function App() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Router>
                <ScrollToTop/>
                <Switch>
                    <Route exact path="/">
                        <Top/>
                    </Route>
                    <Route path="/author">
                        <Author/>
                    </Route>
                    <Route path="/authorwill">
                        <AuthorWill/>
                    </Route>
                    <Route exact path="/property" component={Property} />
                    <Route exact path="/testament" component={Testament} />
                    <Route exact path="/heiress" component={Heiress} />
                    <Route exact path="/money" component={Money} />
                    <Route exact path="/deposit" component={Deposit} />
                    <Route exact path="/land" component={Land} />
                    <Route exact path="/building" component={Building} />
                    <Route exact path="/apartment" component={Apartment} />
                    <Route exact path="/stock" component={Stock} />
                    <Route exact path="/fund" component={Fund} />
                    <Route exact path="/insurance" component={Insurance} />
                    <Route exact path="/bond" component={Bond} />
                    <Route exact path="/debt" component={Debt} />
                    <Route exact path="/automobile" component={Automobile} />
                    <Route exact path="/other" component={Other} />
                </Switch>
            </Router>
        </div>
    );
}

export default App;
